/** Shop name generator + filter (Flow A step I). Word lists come from the locale file. */

// Minimal client-side blocklist; the server filters again (ShopNameRequest).
const BLOCK = ['fuck', 'shit', 'bitch', 'cunt', 'dick', 'cock', 'pussy', 'nigg', 'fag', 'slut', 'whore', 'rape', 'nazi', 'porn'];

const LEET: Record<string, string> = { '0': 'o', '1': 'i', '3': 'e', '4': 'a', '5': 's', '7': 't', '@': 'a', $: 's' };

export type NameCheck = { ok: true; name: string } | { ok: false; reason: 'short' | 'long' | 'chars' | 'blocked' };

export function normalizeName(raw: string): string {
  return raw.replace(/\s+/g, ' ').trim();
}

export function checkShopName(raw: string): NameCheck {
  const name = normalizeName(raw);
  if (name.length < 2) return { ok: false, reason: 'short' };
  if (name.length > 24) return { ok: false, reason: 'long' };
  if (!/^[\p{L}\p{N} '&.!-]+$/u.test(name)) return { ok: false, reason: 'chars' };
  const flat = name
    .toLowerCase()
    .split('')
    .map((c) => LEET[c] ?? c)
    .join('')
    .replace(/[^a-z]/g, '');
  if (BLOCK.some((w) => flat.includes(w))) return { ok: false, reason: 'blocked' };
  return { ok: true, name };
}

/**
 * A random "<adjective> <noun>" name. Word order is the locale's (`name.pattern`, e.g.
 * "{adj} {noun}" in English, "{noun} {adj}" where adjectives follow), passed in as `compose`.
 */
export function suggestShopName(adjectives: string[], nouns: string[], rnd: () => number, compose: (adj: string, noun: string) => string = (a, n) => `${a} ${n}`): string {
  const pick = (a: string[]) => (a[Math.floor(rnd() * a.length)] ?? '').trim();
  return normalizeName(compose(pick(adjectives), pick(nouns))).slice(0, 24);
}
